$(function(){
    const $document = $(document);

    var modals = [];
    var modalsData = [];
    var listLoaded = false;

    var Cart = {
        loadList: function(){
            $.ajax({
                url: '/ecommerce/cart/',
                dataType: 'json',
                success: function(data){
                    $('[js-ecommerce-cart-list-original]').html(data.list);

                    $('[js-ecommerce-cart-amount]').text(data.amount);


                    if(!$('[js-ecommerce-cart-open]').length && data.amount > 0){
                        $('[js-ecommerce-cart]').prepend(data.button)
                    }

                    listLoaded = true;
                }
            });
        }
    };

    $document.on('click', '[js-close-modal]', function(e) {
        e.preventDefault();
        var $modal = $('.modal-box');
        if(modals.length > 0){
            $modal.html(modals.pop());
            $modal.find('.form-overlay').remove();

            $modal.fromJSON(modalsData.pop());
        }
        $document.on('click', '.arcticmodal-close', function(e) {
            $.arcticmodal('close');
        });
    });

    var ecommerceBuyClick = function(){
        $.arcticmodal('close');
        var $elem = $(this);
        var $modal = $$.openModal($('<div class="modal-box__loading"></div>'), {
            afterClose: function($form){
                modals = [];
            }
        }).addClass('modal-box_loading');

        $.ajax({
            url: $elem.data('url'),
            beforeSend: function(){

            },
            success: function(data){
                $modal
                    .removeClass('modal-box_loading')
                    .find('.modal-box-content')
                    .html(data)
                ;

                $$.init.formPlugins($modal);

                var firstModalHandler = {
                    overlay: true,
                    beforeData: function($form){
                        $form.closest('.modal-box').append($('<div class="modal-box__loading"></div>'));
                    },
                    afterData: function($form, data){
                        $form.closest('.modal-box').find('.modal-box__loading').remove();
                    },
                    success: function(data, $form){
                        var $modal = $form.closest('.modal-box');
                        $modal.find('.modal-box__loading').remove();

                        modals.push($modal.html());
                        modalsData.push($modal.toJSON());

                        $form
                            .closest('.modal-box')
                            .find('.modal-box-content')
                            .html(data.html)
                        ;

                        $modal.find('[js-close-modal-first]').on('click', function(e) {
                            e.preventDefault();
                            if(modals.length > 0){
                                $modal.html(modals.pop());
                                $modal.find('.form-overlay').remove();

                                $modal.find('[js-ecommerce-section-list]').formHandle(firstModalHandler);

                                $modal.fromJSON(modalsData.pop())
                            }
                        });

                        $$.init.formPlugins($modal);
                    }
                };

                $modal.find('[js-ecommerce-section-list]').formHandle(firstModalHandler);
            }
        });
    };

    $('[js-ecommerce-section-buy]').on('click', ecommerceBuyClick);


    $document.on('click', '[js-ecommerce-section-prolongation]', function(e){
        e.preventDefault();

        var $elem = $(this);
        var $modal = $$.openModal($('<div class="modal-box__loading"></div>')).addClass('modal-box_loading');

        $.ajax({
            url: $elem.data('url'),
            type: 'post',
            dataType: 'json',
            success: function(response){
                $modal
                    .removeClass('modal-box_loading');
                if (response.error) {
                    $modal
                        .find('.modal-box-content')
                        .html(response.error)
                    ;
                } else {
                    $modal
                        .find('.modal-box-content')
                        .html(response.html)
                    ;

                    $$.init.formPlugins($modal);
                }
            }
        });

    });


    $document.on('click', '[js-ecommerce-cart-action]', function(e){
        e.preventDefault();
        var $elem = $(this),
            type = $elem.data('type'),
            $container = $elem.closest('[data-id]')
        ;

        if($elem.data('in-cart')){
            $('[js-ecommerce-cart-order]').trigger('click');

            if (!listLoaded) {
                return;
            }
            listLoaded = false;
            var $elemCart = $('[js-ecommerce-cart-order]');

            $.ajax({
                url: $elemCart.data('url'),
                beforeData: function(){
                    $('.modal-box').closest('.modal-box').append($('<div class="modal-box__loading"></div>'));
                },
                afterData: function(){
                    $('.modal-box').closest('.modal-box').find('.modal-box__loading').remove();
                },
                success: function(data){

                    var $modal = $('.modal-box');

                    modals.push($modal.html());
                    modalsData.push($modal.toJSON());

                    $modal
                        .find('.modal-box-content')
                        .html(data)
                    ;

                    console.log($modal);

                    $$.init.formPlugins($modal);
                }
            });

            return;
        }

        if($elem.data('banned')){
            $$.openModal($('[js-section-buy-water]'));
            return;
        }

        $.ajax({
            type: type,
            url: '/ecommerce/cart/'+$container.data('id')+'/',
            beforeSend: function(){
                $$.blockOverlay($container);
            },
            success: function(data){
                $$.blockOverlay($container);

                var $modal = $('.modal-box');
                if (modals.length === 2) {
                    modals.pop();
                    modals.push($modal.html());
                }

                if(type == 'post'){
                    $('[js-ecommerce-cart-action][data-template-id="'+$elem.data('template-id')+'"]')
                        .removeClass('button_green')
                        .removeClass('ecommerce-section__buy-button_active')
                        .data('in-cart', 0)
                        .text('купить')
                    ;

                    $elem
                        .text('оформить')
                        .addClass('button_green ecommerce-section__buy-button_active')
                        .data('in-cart', 1)
                    ;

                }else if(type == 'delete'){
                    $container.slideUp(300, function(){
                       $(this).remove();
                    });
                }

                $('[js-ecommerce-cart-total]').text(data.price_formatted);

                if(data.amount == 0){
                    $('.ecommerce-cart-modal').arcticmodal('close');
                    $('[js-ecommerce-cart-list-original]').html('');
                    $('[js-ecommerce-cart-open]').remove();
                }

                Cart.loadList();
            }
        });
    });

    $document.on('click', '[js-ecommerce-cart-open]', function(e){
        e.preventDefault();
        $$.openModal($('[js-ecommerce-cart-modal]'), {
            beforeOpen: function(modal, $modal){
                $modal.removeClass('modal-box').addClass('ecommerce-cart-modal');
                $modal.find('.modal-box-content').css({ minHeight: $(window).height() });
                setTimeout(function(){
                    $modal.addClass('ecommerce-cart-modal_opened');
                }, 10);

            },
            afterOpen: function(modal, $modal){

            },
            beforeClose: function(modal, $modal){
                $modal.removeClass('ecommerce-cart-modal_opened');
            },
            openEffect: {
                type: 'fade',
                speed: 300
            },
            closeEffect: {
                type: 'fade',
                speed: 300
            }
        });
    });

    $document.on('click', '[js-ecommerce-cart-order]', function(){

        var $elem = $(this);
        var $modal = $('.modal-box').addClass('modal-box_loading');
        ;

        if(!$modal.length) {
            $modal = $$.openModal($('<div class="modal-box__loading"></div>')).addClass('modal-box_loading');
        }

        $.ajax({
            url: $elem.data('url'),
            success: function(data){

                var $modal = $('.modal-box');
                $modal.find('.modal-box__loading').remove();

                modals.push($modal.html());
                modalsData.push($modal.toJSON());

                $modal
                    .find('.modal-box-content')
                    .html(data)
                ;

                $$.init.formPlugins($modal);

                buyBonusInit($modal);
            }
        });

    });

    $document.on('click', '[js-input-phone-code]', function(){
        var $elem = $(this),
            $form = $elem.closest('form'),
            $wrapper = $elem.closest('.input-wrapper'),
            $input = $wrapper.find('input[type=text]')
        ;

        if($elem.data('blocked')) return;


        if(!$input.val()){
            $input.focus();
            return;
        }

        $wrapper.find('.input__error').remove();
        $wrapper.find('.is-error').removeClass('is-error');

        var action = $elem.data('action') == 'change' ? 'changePhone' : 'sendCode';

        $.ajax({
            url: '/ecommerce/'+action+'/',
            data: {phone: $input.val()},
            type: 'post',
            beforeSend: function(){
                //$$.blockOverlay($wrapper);

                if($elem.data('action') == 'confirm'){
                    $$.blockOverlay($wrapper);
                }else{
                    $form.find('button[type="submit"]').attr('disabled', 'disabled');
                }
            },
            success: function(data){
                $elem.data('blocked', false);
                $$.blockOverlay($wrapper);



                if(data.success){
                    if($elem.data('action') == 'confirm'){
                        $form
                            .find('[js-input-phone-confirm-code]')
                            .data('block-overlay', null)
                            .slideDown()
                            .find('input')
                                .val('')
                                .focus()
                                .removeAttr('readonly')
                            .end()
                                .find('.block-overlay')
                                .remove()
                            .end()
                            .find('button')
                                .removeClass('button_blue')
                                .addClass('button_green')
                                .data('blocked', false)
                                .text('Подтвердить')
                        ;

                        $input.attr('readonly', 'readonly');
                        $$.blockOverlay($wrapper);

                        $elem
                            .data('action', 'change')
                            .addClass('ecommerce-phone-confirm-button_change')
                            .addClass('button_outline')
                            .text('Изменить')
                        ;

                    }else{
                        $form.find('[js-input-phone-confirm-code]').slideUp();
                        $input.removeAttr('readonly', 'readonly');

                        $elem
                            .data('action', 'confirm')
                            .removeClass('button_outline')
                            .text('Получить код')
                        ;

                        $input.val('').focus();
                    }

                }else{
                    $.each(data.error, function(key, value){
                        $$.uniFormShowError($input, value);
                    });
                }

            }
        });
    });

    $document.on('click', '[js-input-phone-confirm]', function(){
        var $elem = $(this),
            $form = $elem.closest('form'),
            $wrapper = $elem.closest('.input-wrapper'),
            $input = $wrapper.find('input[type=text]')
        ;

        if($elem.data('blocked')) return;


        if(!$input.val()){
            $input.focus();
            return;
        }

        $wrapper.find('.input__error').remove();
        $wrapper.find('.is-error').removeClass('is-error');

        $elem.data('blocked', true);

        $.ajax({
            url: '/ecommerce/confirmPhone/',
            type: 'post',
            data: {code: $input.val()},
            beforeSend: function(){
                $$.blockOverlay($wrapper);
            },
            success: function(data){
                $$.blockOverlay($wrapper);
                $elem.data('blocked', false);

                if(data.success){
                    $input.attr('readonly', 'readonly');
                    $$.blockOverlay($wrapper);

                    $elem
                        .data('blocked', true)
                        .removeClass('button_green')
                        .addClass('button_blue')
                        .text('Подтвержден');

                    $form.find('button[type="submit"]').removeAttr('disabled');
                }else{
                    $.each(data.error, function(key, value){
                        $$.uniFormShowError($input, value);
                    });
                }
            }
        });

    });

    function buyBonusInit($modal){
        var $cardBonusCheckbox = $modal.find('[js-ecommerce-card-bonus-use-checkbox]');
        var $cardBonusInputContainer = $modal.find('[js-ecommerce-card-bonus-value]');
        var $cardBonusInput = $modal.find('[js-ecommerce-card-bonus-value-input]');
        var $cardTotal = $modal.find('[js-ecommerce-card-total]');
        var $cardTotalValue = $cardTotal.find('[js-ecommerce-card-total-value]');
        var totalPrice = +$cardTotalValue.data('price');
        var maxApplyBonus = +$cardBonusInput.data('max');


        function bonusRender(instant){
            if($cardBonusCheckbox.prop('checked')){
                $cardBonusInputContainer.stop(true).show(instant ? 0 : 300);
                $cardTotal.stop(true).show(instant ? 0 : 300);
                setTimeout(function(){
                    $cardBonusInput.focus();
                }, instant ? 0 : 300);
            }else{
                $cardBonusInputContainer.stop(true).hide(instant ? 0 : 300);
                $cardTotal.stop(true).hide(instant ? 0 : 300);
            }
        }

        function calcTotal(){
            $cardTotalValue.text(totalPrice - $cardBonusInput.val());
        }

        $cardBonusCheckbox.on('change', bonusRender);

        $cardBonusInput.on('input', function(){
            var value = +$cardBonusInput.val() || 0;
            value = value.toFixed(0);

            if(value > maxApplyBonus) {
                value = maxApplyBonus;
            }

            if(value < 0) {
                value = 0;
            }

            $cardBonusInput.val(value);

            calcTotal();
        });

        bonusRender(true);
    }

    var step1_2FormSubmit = function(e){
        e.preventDefault();
        $$.uniFormSubmit($(this), {
            overlay: true,
            beforeData: function($form){
                $form.closest('.modal-box').append($('<div class="modal-box__loading"></div>'));
            },
            afterData: function($form){
                $form.closest('.modal-box').find('.modal-box__loading').remove();
            },
            success: function(data, $form){
                var $modal = $form.closest('.modal-box');
                $modal.find('.modal-box__loading').remove();

                modals.push($modal.html());
                modalsData.push($modal.toJSON());

                $form
                    .closest('.modal-box-content')
                    .html(data.form);

                $$.init.formPlugins($modal);

                buyBonusInit($modal);
            }
        });
    };
    

    var step3FormSubmit = function(e){
        e.preventDefault();

        $$.uniFormSubmit($(this), {
            overlay: true,
            beforeData: function($form){
                $form.closest('.modal-box').append($('<div class="modal-box__loading"></div>'));
            },
            afterData: function($form){
                $form.closest('.modal-box').find('.modal-box__loading').remove();
            },
            success: function(data, $form){
                var $modal = $form.closest('.modal-box');
                $modal.find('.modal-box__loading').remove();

                modals.push($modal.html());
                modalsData.push($modal.toJSON());

                $form
                    .closest('.modal-box-content')
                    .html(data.form);

                if(data.redirect){
                    document.location.href = data.redirect;
                }
            }
        });

    };

    $document.on('submit', '[js-ecommerce-order-step1]', step1_2FormSubmit);
    $document.on('submit', '[js-ecommerce-order-step2]', step1_2FormSubmit);
    $document.on('submit', '[js-ecommerce-order-step3]', step3FormSubmit);

    $('[js-ecommerce-card-buy]').on('click', ecommerceBuyClick);

    $document.on('submit', '[js-ecommerce-orderCard-step1]', step1_2FormSubmit);
    $document.on('submit', '[js-ecommerce-orderCard-step2]', step1_2FormSubmit);
    $document.on('submit', '[js-ecommerce-orderCard-step3]', step3FormSubmit);

});

(function($) {
    $.fn.toJSON = function() {
        var $elements = {};
        var $form = $(this);
        $form.find('input, select, textarea').each(function(){
            var name = $(this).attr('name');
            var type = $(this).attr('type');
            if(name){
                var $value;
                if(type === 'radio'){
                    $value = $('input[name='+name+']:checked', $form).val()
                } else if(type === 'checkbox'){
                    $value = $(this).is(':checked')
                } else {
                    $value = $(this).val()
                }
                $elements[$(this).attr('name')] = $value
            }
        });
        return JSON.stringify( $elements )
    };
    $.fn.fromJSON = function(json_string) {
        var $form = $(this);
        var data = JSON.parse(json_string);
        $.each(data, function(key, value) {
            var $elem = $('[name="'+key+'"]', $form);
            var type = $elem.first().attr('type');
            if(type === 'radio'){
                $('[name="'+key+'"][value="'+value+'"]').prop('checked', true)
            } else if(type === 'checkbox' && (value === true || value === 'true')){
                $('[name="'+key+'"]').prop('checked', true)
            } else {
                $elem.val(value)
            }
        })
    };
}( jQuery ));